import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRoute } from "vue-router";
type TabType = "referrer" | "referred";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReferNav',
  setup(__props) {

const referrerRoute = { name: "ReferPromotion", query: { tab: "referrer" } };
const referredRoute = { name: "ReferPromotion", query: { tab: "referred" } };

const route = useRoute();

const activeTab = computed(() => {
  return route.query.tab as TabType;
});

const isActiveTab = (expectedTab: TabType) => {
  return activeTab.value === expectedTab;
};

return (_ctx: any,_cache: any) => {
  const _component_BNavItem = _resolveComponent("BNavItem")!
  const _component_BNav = _resolveComponent("BNav")!

  return (_openBlock(), _createBlock(_component_BNav, { fill: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_BNavItem, {
        to: referrerRoute,
        class: "nav-item",
        active: isActiveTab('referrer')
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n      招待の手順\n    ")
        ], undefined, true),
        _: 1
      }, 8, ["active"]),
      _createTextVNode(),
      _createVNode(_component_BNavItem, {
        to: referredRoute,
        class: "nav-item",
        active: isActiveTab('referred')
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n      招待された方\n    ")
        ], undefined, true),
        _: 1
      }, 8, ["active"])
    ], undefined, true),
    _: 1
  }))
}
}

})